import { useCallback, useState } from 'react';
// Potential: import { formatDate } from '@readsavor/utils'; // If a shared util exists
// Local helper function for date formatting (can be moved to utils later)
const formatDate = (timestamp) => {
    if (!timestamp)
        return 'Unknown time'; // Handle potential null/undefined timestamps
    try {
        // Use a locale-neutral format that is easily understandable, e.g., 'en-US' or 'en-CA' for YYYY-MM-DD
        return new Date(timestamp).toLocaleString('en-US', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hour12: false,
        });
    }
    catch (e) {
        console.error('Error formatting date:', e);
        return 'Invalid date';
    }
};
/**
 * Hook to encapsulate the logic for a single history list item.
 * Prepares data and callbacks for the HistoryListItemUI component.
 */
export const useHistoryItemLogic = ({ item, onSelect, onDelete }) => {
    // Add state for expansion
    const [isDetailsExpanded, setIsDetailsExpanded] = useState(false);
    const [isSummaryExpanded, setIsSummaryExpanded] = useState(false);
    const formattedTimestamp = formatDate(item.timestamp);
    // Toggle functions
    const toggleDetails = useCallback(() => {
        setIsDetailsExpanded(prev => !prev);
        // Optional: Collapse summary when details expand, and vice-versa?
        // if (!isDetailsExpanded) setIsSummaryExpanded(false);
    }, []);
    const toggleSummary = useCallback(() => {
        setIsSummaryExpanded(prev => !prev);
        // Optional: Collapse details when summary expands?
        // if (!isSummaryExpanded) setIsDetailsExpanded(false);
    }, []);
    // Wrapped callback for selecting the item
    const handleSelectClick = useCallback(() => {
        if (onSelect && item.identity) {
            onSelect(item.identity);
        }
    }, [onSelect, item.identity]);
    // Wrapped callback for deleting the item
    const handleDeleteClick = useCallback((event) => {
        event?.stopPropagation(); // Prevent triggering onSelectClick on the parent li
        if (onDelete && item.identity) {
            onDelete(item.identity, item.title);
        }
    }, [onDelete, item.identity, item.title]);
    // Determine preview content based on document type
    const previewContent = item.identity.type === 'pdf' ? '' : item.preview || '';
    return {
        // Data formatted and ready for the UI component
        title: item.title || 'Untitled', // Provide fallback
        preview: previewContent, // Use the conditional preview content
        formattedTimestamp,
        language: item.language || 'Unknown', // Provide fallback
        targetLanguage: item.targetLanguage || 'Unknown', // Provide fallback
        identity: item.identity,
        // Expansion states
        isDetailsExpanded,
        isSummaryExpanded,
        // Callbacks ready to be passed directly to the UI component's props
        // Conditionally provide callbacks only if the original function was passed
        handleSelectClick: onSelect ? handleSelectClick : undefined,
        handleDeleteClick: onDelete ? handleDeleteClick : undefined,
        // Pass toggle functions instead of old handlers
        toggleDetails,
        toggleSummary,
    };
};
//# sourceMappingURL=useHistoryItemLogic.js.map